import React, { useState, useEffect } from "react";
import { getLanguage } from "react-switch-lang";
import en from "./en.json";
import ma from "./ma.json";
import "./Guidance.css";
// import illustration from "./assets/home_icons/Home Page_website-17.webp";
import whatsappIcon from "./assets/home_icons/whatsapp.svg";

const translationData = { en: en, ma: ma };
const guidanceBg =
  "https://res.cloudinary.com/dtuy184dc/image/upload/f_auto,q_auto,w_1400/v1775113658/card_background_1_f5sgey.png";
// WhatsApp will use external image as requested (see Guidance.css .whatsapp-img)

const PhoneIcon = () => (
  <svg
    className="icon-inline"
    viewBox="0 0 640 640"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M224.2 89C216.3 70.1 195.7 60.1 176.1 65.4L170.6 66.9C106 84.5 50.8 147.1 66.9 223.3C104 398.3 241.7 536 416.7 573.1C493 589.3 555.5 534 573.1 469.4L574.6 463.9C580 444.2 569.9 423.6 551.1 415.8L453.8 375.3C437.3 368.4 418.2 373.2 406.8 387.1L368.2 434.3C297.9 399.4 241.3 341 208.8 269.3L253 233.3C266.9 222 271.6 202.9 264.8 186.3L224.2 89z" />
  </svg>
);

const Guidance = () => {
  const [language, setLanguage] = useState(() => getLanguage() || "en");

  const t = (key) => {
    const langKey = language === "ma" ? "ma" : "en";
    return translationData[langKey]?.[key] || "";
  };

  useEffect(() => {
    const checkLang = () => {
      const current = getLanguage() || "en";
      setLanguage((prev) => (prev !== current ? current : prev));
    };
    checkLang();
    const interval = setInterval(checkLang, 300);
    window.addEventListener("storage", checkLang);
    return () => {
      clearInterval(interval);
      window.removeEventListener("storage", checkLang);
    };
  }, []);

  return (
    <section className="guidance-section">
      <div
        className="guidance-container"
        style={{
          backgroundImage: `url(${guidanceBg})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center top",
          backgroundSize: "cover",
        }}
      >
        <div className="guidance-decoration" aria-hidden>
          <svg
            className="guidance-leaf guidance-leaf--top-left"
            viewBox="0 0 120 120"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M30,60 Q40,40 60,45 Q50,55 45,70 Z"
              fill="currentColor"
              opacity="0.3"
            />
            <path
              d="M40,70 Q50,50 70,55 Q60,65 55,80 Z"
              fill="currentColor"
              opacity="0.3"
            />
          </svg>
          <svg
            className="guidance-leaf guidance-leaf--bottom-right"
            viewBox="0 0 200 200"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M100,20 Q80,50 70,80 Q75,70 85,60 Q80,75 75,90 Q80,85 90,75 Q85,90 80,105 Q85,100 95,90 Q90,105 85,120"
              stroke="currentColor"
              strokeWidth="2"
              fill="none"
              opacity="0.3"
            />
          </svg>
        </div>
        <div className="guidance-left">
          <img
            src="https://res.cloudinary.com/dtuy184dc/image/upload/f_auto,q_auto,w_500/v1775119802/Home_Page_website-17_dmec9k.png"
            alt="Seeking Guidance"
            className="guidance-illustration"
            loading="eager"
          />
        </div>
        <div className="guidance-center">
          <h2 className="guidance-title">{t("guidance_title")}</h2>
          <p className="guidance-sub">{t("guidance_sub")}</p>
        </div>
        <div className="guidance-right">
          <div className="guidance-hours">
            <i class="far fa-clock" style={{ marginRight: "5px" }}></i>
            {t("guidance_hours")}
          </div>
          <a
            className="guidance-cta"
            href="tel:+919856074655    "
            aria-label="Call helpline 88560 74655"
          >
            <span className="whatsapp-icon">
              <img
                className="whatsapp-img"
                src={whatsappIcon}
                alt="whatsapp"
                loading="lazy"
                decoding="async"
              />
            </span>
            <span className="phone-icon">
              <PhoneIcon />
            </span>
            <span className="cta-text">{t("guidance_cta")}</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Guidance;
